import Base from '../Base';
export default class FaitsSaillants extends Base {
    init(id, main, locale) {
        loadScript('https://unpkg.com/swiper/swiper-bundle.min.js', onLoadSwiperScript);

        /* Overlay mobile pour tableaux Faits saillants*/
        $('.table-scroller').on('scroll', () => {
            $('.table-overlay').css('display', 'none');
        });

        $('.table-scroller').on('click', () => {
            $('.table-overlay').css('display', 'none');
        });

        function loadScript(src, callback) {
            const script = document.createElement('script');
            script.type = 'text/javascript';
            document.body.appendChild(script);
            script.onload = callback;
            script.src = src;
        }
        function onLoadSwiperScript() {
            // Open and close mobile menu
            $('#sticky-menu-mobile .btn, #sticky-menu-mobile a').not('.logo').click(()=> {
                $('#sticky-menu-mobile .btn, #sticky-menu-mobile ul').toggleClass('open');
            });

            const mySwiper = new Swiper('.swiper-container', {
                loop: true,
                slidesPerView: 'auto',
                loopedSlides: 10,
                allowTouchMove: false,
            });

            const stickyMenuDesktop = document.getElementById('sticky-menu-desktop');
            const stickyMenuMobile = document.getElementById('sticky-menu-mobile');
            const showMenuOffset = document.getElementById('eod-2018').offsetTop;

            let sections = [];
            let breakpoints = [];

            getSections();
            $(window).resize(() => {
                getSections();
            });

            window.onscroll = onScroll;
            $(window).trigger('scroll');

            function getSections() {
                sections = $('main#faits-saillants section');
                breakpoints = [];

                sections.each((i, el) => {
                    breakpoints.push({
                        id: el.id,
                        top: Math.floor($(el).offset().top),
                        text: $(el).find('h2').text(),
                    });
                });
            }
            function onScroll() {
                const currentScroll = window.pageYOffset + 30 || document.documentElement.scrollTop + 30;
                // Ajout class visible quand on dépasse le menu du haut
                if (currentScroll >= showMenuOffset) {
                    stickyMenuDesktop.classList.add('visible');
                    stickyMenuMobile.classList.add('visible');
                } else {
                    stickyMenuDesktop.classList.remove('visible');
                    stickyMenuMobile.classList.remove('visible');
                }

                let currentSection = {};
                let lastScrollTop = 0;

                for (let i = 0; i < breakpoints.length; i++) {
                    if (currentScroll > lastScrollTop) {
                        if (currentScroll >= breakpoints[i].top) {
                            currentSection = breakpoints[i];
                        }
                    } else if (currentScroll < breakpoints[i].top) {
                        currentSection = breakpoints[i];
                    }
                }
                lastScrollTop = currentScroll <= 0 ? 0 : currentScroll; // For Mobile or negative scrolling

                setCurrentSection(currentSection);
            }
            function setCurrentSection(breakpoint) {
                if (breakpoints.indexOf(breakpoint) != - 1) {
                    mySwiper.slideTo(breakpoints.indexOf(breakpoint) + $('.swiper-slide-duplicate').length / 2);
                    $('#current-section').text(breakpoint.text);
                }
            }
        }
    }
}